enum WaybillPrintedEnum {
    'ALL' = 'ALL',

    'PRINTED' = 'PRINTED',

    'UNPRINTED' = 'UNPRINTED',
}
export default WaybillPrintedEnum